import { render, staticRenderFns } from "./AddInternalInformation.vue?vue&type=template&id=09b35510"
import script from "./AddInternalInformation.vue?vue&type=script&lang=ts"
export * from "./AddInternalInformation.vue?vue&type=script&lang=ts"
import style0 from "./AddInternalInformation.vue?vue&type=style&index=0&id=09b35510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports